import { Pipe, PipeTransform } from '@angular/core';
import { ReservationDetailsTabType } from './../../_modules/reservations/enum/resDetailsTabsType.enum';

@Pipe({ name: 'tabTypeString' })
export class TabTypeStringPipe implements PipeTransform {
    transform(value: ReservationDetailsTabType): string {
        if (value) {
            switch (value) {
                case ReservationDetailsTabType.COMMUNICATION:
                    return 'Komunikacija z MDPŠ';
                case ReservationDetailsTabType.REPORT:
                    return 'Spričevalo';
                case ReservationDetailsTabType.REFERRAL:
                    return 'Napotnica';
                case ReservationDetailsTabType.STATUS:
                    return 'Stanje';
                default:
                    return value;
            }
        }
        return '(Ni podatka)';
    }
}
